import '@albelli/arc-3/lib/promobar.css';
import { Alert } from '@albelli/arc-3-react';

import VoucherBlock from './voucher';
import Trans from '../translations/trans';
import Countdown from './countdown';
import { getDiscountPercentage } from '../../helpers/discountPercentage';
import { BnclCampaign } from '../../types/voucher';
import { JSX } from 'preact';

type VouchersProps = {
    campaignData: BnclCampaign;
    isPreview: boolean;
};

const Vouchers = ({ campaignData, isPreview }: VouchersProps): JSX.Element => {
    const discounts = campaignData.vendorCampaign.offers.map((offer) =>
        getDiscountPercentage(offer.productPrice, offer.voucherPrice)
    );
    const maxDiscount = Math.max(...(discounts.length ? discounts : [0]));
    return (
        <>
            <div className='wrapper'>
                {isPreview && (
                    <Alert data-cy='PreviewPageAlert' warning>
                        This is the campaign preview page
                    </Alert>
                )}
                <Countdown campaignEndDate={campaignData.endDate} maxDiscount={maxDiscount} />
                <div className='title-container'>
                    <h2 data-cy='MainTitle' className='arc3-typo--text-center arc3-margin--top-xl'>
                        {campaignData.vendorCampaign.pageDetails.title.replaceAll('{XX}', maxDiscount.toString())}
                    </h2>
                    <p
                        data-cy='MainDescription'
                        className='arc3-typo--text-center arc3-padding--max-container arc3-text-center arc3-text-center--medium'
                    >
                        {campaignData.vendorCampaign.pageDetails.subtitle.replaceAll('{XX}', maxDiscount.toString())}
                    </p>
                </div>

                <div className='arc3-flex-wrapper --justify-content-space-evenly --flex-direction-row arc3-margin-t-b arc3-margin--right-lger arc3-margin--left-lger voucher-blocks-wrapper'>
                    {campaignData.vendorCampaign.offers.map((offer) => (
                        <VoucherBlock offer={offer} key={offer.voucherId} />
                    ))}
                </div>
            </div>
            <div className='wrapper arc3-padding'>
                <h4 className='terms-title arc3-margin--right-lger arc3-margin--left-lger'>
                    <Trans transKey='discountOverview.termsAndConditions.title' />
                </h4>

                <p className='terms-content arc3-margin--right-lger arc3-margin--left-lger'>
                    <Trans transKey='bncl.termsAndConditions.description' />
                </p>
            </div>
        </>
    );
};

export default Vouchers;
